import axios from "axios";

export const adminListCourses = async ({ page = 1, limit = 50, search = "" } = {}) => {
  const { data } = await axios.get("/api/admin/courses", { params: { page, limit, search } });
  return data;
};

export const adminGetCourse = async (id) => {
  const { data } = await axios.get(`/api/admin/courses/${id}`);
  return data;
};

export const adminCreateCourse = async (payload) => {
  const { data } = await axios.post("/api/admin/courses", payload);
  return data;
};

export const adminUpdateCourse = async (id, payload) => {
  const { data } = await axios.put(`/api/admin/courses/${id}`, payload);
  return data;
};

export const adminDeleteCourse = async (id) => {
  const { data } = await axios.delete(`/api/admin/courses/${id}`);
  return data;
};

export const adminUpdateCourseStatus = async (id, isActive) => {
  const { data } = await axios.patch(`/api/admin/courses/${id}/status`, { isActive });
  return data;
};


